import { StyleSheet } from 'react-native';
import { PALETTE, TYPOGRAPHY, MQ_TABLET, DBK_FONT_FAMILY} from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({
  root: {
    backgroundColor: 'transparent',
    fontFamily: DBK_FONT_FAMILY.dbkText,
    letterSpacing: 0.1,
  },
  primary: {
    color: PALETTE.primaryText,
  },
  primaryDisabled: {
    color: PALETTE.primaryTextDisabled,
  },
  secondary: {
    color: PALETTE.secondaryText,
  },
  secondaryDisabled: {
    color: PALETTE.secondaryTextDisabled,
  },
  xxsmall: {
    fontSize: TYPOGRAPHY.font.size.xxsmall,
  },
  xsmall: {
    fontSize: TYPOGRAPHY.font.size.xsmall,
  },
  small: {
    fontSize: TYPOGRAPHY.font.size.small,
  },
  normal: {
    fontSize: TYPOGRAPHY.font.size.normal,
  },
  large: {
    fontSize: TYPOGRAPHY.font.size.large,
  },
  header1: {
    fontSize: TYPOGRAPHY.font.size.header1,
  },
  header2: {
    fontSize: TYPOGRAPHY.font.size.header2,
  },
  header3: {
    fontSize: TYPOGRAPHY.font.size.header3,
  },
  header4: {
    fontSize: TYPOGRAPHY.font.size.header4,
  },
  center: {
    textAlign: 'center',
  },
  left: {
    textAlign: 'left',
  },
  right: {
    textAlign: 'right',
  }
}, {
  [MQ_TABLET]: {
    xxsmall: {
      fontSize: TYPOGRAPHY.font.tabletSize.xxsmall,
    },
    xsmall: {
      fontSize: TYPOGRAPHY.font.tabletSize.xsmall,
    },
    small: {
      fontSize: TYPOGRAPHY.font.tabletSize.small,
    },
    normal: {
      fontSize: TYPOGRAPHY.font.tabletSize.normal,
    },
    large: {
      fontSize: TYPOGRAPHY.font.tabletSize.large,
    },
    header1: {
      fontSize: TYPOGRAPHY.font.tabletSize.header1,
    },
    header2: {
      fontSize: TYPOGRAPHY.font.tabletSize.header2,
    },
    header3: {
      fontSize: TYPOGRAPHY.font.tabletSize.header3,
    },
    header4: {
      fontSize: TYPOGRAPHY.font.tabletSize.header4,
    },
  }
});
